import { PropTypes } from "prop-types"

import Translate from "../Translate"

/**
 * Tag component
 * Used to display promo information to user
 * @export {function} Tag component
 * @param {*} props
 * @returns {span} tag
 */
export default function Tag(props) {
  const { label, children } = props

  return (
    <span className="oj-tag">
      {label && <Translate id={label} />}
      {children}
    </span>
  )
}

Tag.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node
}
